export const FAVOURITE_FILTERS_KEY = 'favouriteFilters';
export const FAVORITES_UPDATED_EVENT = 'favoritesUpdated';